export default "__VITE_ASSET__Cd1md_Ux__"